//ƒpie//Closure to encapsulate all JS

// polyfills
require('classlist-polyfill');
require('es6-object-assign').polyfill();
require('es6-promise').polyfill();
require('element-closest-polyfill');

var version = '1.0.1';

var UTILS = {
    merge: require('lodash.merge'),
    classlist: require('dom-classlist'),
    throttle: require('lodash.throttle'),
    loadScript: require('load-script'),
    tools: require('storm-utils'),
    cookies: require('./require/cookie-functions')
},
    UI = (function (w, d) {
        'use strict';
        var ffo = require('FontFaceObserver'), //installed via npm install --save fontfaceobserver to node_modules
            Toggler = require('storm-toggler').default, //required from local directory
            //Modal = require('./require/modal'),
            Modal = require('./require/storm-modal'),
            initCookieBanner = function () {
                //detect and return if not needed
                if (!(d.querySelector('.cookie-banner'))) { return; }
                //loaded async as required
                STORM.UTILS.loadScript(`/content/js/async/cookie-banner.min.js?v=${version}`, function (err) {
                    if (err) {
                        return console.log(err);
                    }
                    CookieBanner.init('.cookie-banner');
                });
            },
            initCookieSettings = function() {
                //detect and return if not needed
                if (!(d.querySelector('[data-module="cookie-settings"]'))) { return; }
                //loaded async as required
                STORM.UTILS.loadScript(`/content/js/async/cookie-settings.min.js?v=${version}`, function (err) {
                    if (err) {
                        return console.log(err);
                    }
                    CookieSettings.init('[data-module="cookie-settings"]');
                });
            },
            initErrorSummary = function () {
                //detect and return if not needed
                if (!(d.querySelector('.error-summary'))) { return; }
                //loaded async as required
                STORM.UTILS.loadScript(`/content/js/async/error-summary.min.js?v=${version}`, function (err) {
                    if (err) {
                        return console.log(err);
                    }
                    new ErrorSummary('.error-summary');
                });
            },
            initFonts = function () {
                var ffo = new FontFaceObserver('Helvetica LT W01 Roman', {})
                    .check()
                    .then(function () {
                        d.documentElement.className = document.documentElement.className.replace(/\bno-webfonts\b/, '');
                    }, function () {
                        console.log('Font is not available after waiting 5 seconds');
                    });
            },
            initQuiz = function () {
                //detect and return if not needed
                if (!(d.querySelector('.panel-quiz'))) { return; }

                var quiz = d.querySelector('.panel-quiz');
                var quizQuestionContainers = quiz.querySelectorAll('.question-container');
                var quizStartButton = quiz.querySelector('#quiz-start');
                var quizEnd = quiz.querySelector('#quiz-end');
                var quizActiveRegion = quiz.querySelector('#quiz-active-region');

                function activateQuizPanel(panel) {
                    var current = quizActiveRegion.children[0];
                    quizActiveRegion.replaceChild(panel, current);
                    panel.classList.add('active');
                }

                quizStartButton.onclick = function (e) {
                    e.preventDefault();
                    var firstQuestion = quizQuestionContainers[0];
                    activateQuizPanel(firstQuestion.children[0]);
                };

                for (var i = 0; i < quizQuestionContainers.length; i++) {
                    var questionContainer = quizQuestionContainers[i];
                    var question = questionContainer.children[0];

                    [].slice.call(question.querySelectorAll('button')).forEach(function (btn) {
                        btn.addEventListener('click', function (e) {
                            e.preventDefault();
                            var questionIndex = parseInt(btn.dataset.questionindex);
                            if (this.dataset.correct === "true") {
                                if (questionIndex === quizQuestionContainers.length - 1) {
                                    activateQuizPanel(quizEnd);
                                }
                                else {
                                    var nextQuestion = quizQuestionContainers[questionIndex + 1];
                                    activateQuizPanel(nextQuestion.children[0]);
                                }
                            } else {
                                var incorrectAnswer = quizQuestionContainers[questionIndex].children[0];
                                activateQuizPanel(incorrectAnswer);
                            }
                        });
                    });
                    var questionText = question.querySelector('.question-text');
                    if (questionText !== null) {
                        var questionAnchors = questionText.querySelectorAll('a');
                        if (questionAnchors.length > 0) {
                            for (var j = 0; j < questionAnchors.length; j++) {
                                var anchor = questionAnchors[j];
                                anchor.onclick = function (e) {
                                    e.preventDefault();
                                    if (this.href.split('#').length > 1) {
                                        var wallPanelId = this.href.split('#')[1];
                                        if (d.getElementById(wallPanelId)) {
                                            d.getElementById(wallPanelId).click();
                                            d.getElementById(wallPanelId).focus({ preventScroll: true });
                                        }
                                    }
                                };
                            }
                        }
                    }
                }


            },
            initSmoothScroll = function () {
                //detect and return if not needed
                if (!(d.querySelector('.js-smooth-scroll'))) { return; }
                //loaded async as required
                STORM.UTILS.loadScript(`/content/js/async/smooth-scroll.min.js?v=${version}`, function (err) {
                    if (err) {
                        return console.log(err);
                    }
                    smoothScroll.init();
                });
            },
            initScrollPoints = function () {
                //detect and return if not needed
                if (!(d.querySelector('.js-scroll-point'))) { return; }
                //loaded async as required
                STORM.UTILS.loadScript(`/content/js/async/scrollpoints.min.js?v=${version}`, function (err) {
                    if (err) {
                        return console.log(err);
                    }
                    ScrollPoints.init('.js-scroll-point', {
                        offset: '15%',
                        class: 'js-is-scrolled-in',
                    });

                });
            },
            initTabsAccordion = function () {
                //detect and return if not needed
                if (!(d.querySelector('.js-tab-accordion'))) { return; }
                //loaded async as required
                STORM.UTILS.loadScript(`/content/js/async/tab-accordion.min.js?v=${version}`, function (err) {
                    if (err) {
                        return console.log(err);
                    }
                    StormTabAccordion.init('.js-tab-accordion');
                });
            },
            initEqualizer = function () {
                //detect and return if not needed
                if (!(d.querySelector('.js-equal-height'))) { return; }
                //loaded async as required
                STORM.UTILS.loadScript(`/content/js/async/storm-equal-height.min.js?v=${version}`, function (err) {
                    if (err) {
                        return console.log(err);
                    }
                    StormEqualHeight.init('.js-equal-height', { minHeight: 0 });
                });
            },
            initWall = function () {
                //detect and return if not needed
                if (!(d.querySelector('.js-wall'))) { return; }
                //loaded async as required
                STORM.UTILS.loadScript(`/content/js/async/wall.min.js?v=${version}`, function (err) {
                    if (err) {
                        return console.log(err);
                    }
                    Wall.init();
                });
            },
            initMap = function () {
                //detect and return if not needed
                if (!(d.querySelector('.js-map')) && !window.googleMapsApiKey) { return; }
                //loaded async as required
                STORM.UTILS.loadScript(`/content/js/async/map.min.js?v=${version}`, function (err) {
                    if (err) {
                        return console.log(err);
                    }

                    var rawLocation = w.mapLocation;

                    if (rawLocation) {
                        var location = rawLocation.split(',');
                        OurMap.asyncGoogleMapAPI(d.querySelector('.js-map'), [
                            {
                                "id": "x",
                                "title": "Location Title",
                                "location": {
                                    "latitude": location[0],
                                    "longitude": location[1]
                                },
                            }
                        ], {
                            map: {
                                APIKey: window.googleMapsApiKey
                            }
                        });
                    }
                    else {
                        OurMap.asyncGoogleMapAPI(d.querySelector('.js-map'), [
                            {
                                "id": "x",
                                "title": "Location Title",
                                "location": {
                                    "latitude": "55.944715",
                                    "longitude": "-3.197048"
                                },
                            }
                        ], {
                            map: {
                                APIKey: window.googleMapsApiKey
                            }
                        });
                    }

                });
            },
            initParallax = function () {
                //detect and return if not needed
                if (!(d.querySelector('.js-parallax'))) { return; }
                //loaded async as required
                STORM.UTILS.loadScript(`/content/js/async/parallax.min.js?v=${version}`, function (err) {
                    if (err) {
                        return console.log(err);
                    }
                    Parallax.init(document.querySelector('.js-parallax'));
                });
            },
            initPies = function () {
                //detect and return if not needed
                if (!(d.querySelector('.js-chart'))) { return; }

                // get accessible blood type name
                function getBloodTypeWithRhesusText(bloodType) {
                    var rhesusSymbol = '';

                    if (bloodType) {
                        bloodType = bloodType.trim();
                        rhesusSymbol = bloodType.slice(-1);
                    }

                    switch (rhesusSymbol) {
                        case '-':
                            return bloodType.slice(0, -1) + ' negative';
                        case '+':
                            return bloodType.slice(0, -1) + ' positive';
                    }

                    return '';
                }

                //loaded async as required
                STORM.UTILS.loadScript(`/content/js/async/easypiechart.min.js?v=${version}`, function (err) {
                    if (err) {
                        return console.log(err);
                    }
                    var pies = [],
                        handler = function (e) {
                            e.preventDefault();
                            d.querySelector('.nav-tab__link--active').className = d.querySelector('.nav-tab__link--active').className.replace('nav-tab__link--active', '');
                            e.target.className = e.target.className + ' nav-tab__link--active';
                            var bloodGroupList = d.createElement('ul');

                            pies.forEach(function (pie) {
                                //console.log(pie.el.getAttribute('data-percentage-' + e.target.getAttribute('data-pie-value')));
                                var currentTargetPercentage = pie.el.getAttribute('data-percentage-' + e.target.getAttribute('data-pie-value'));
                                pie.update(currentTargetPercentage);
                                pie.el.nextElementSibling.innerHTML = currentTargetPercentage + '%';

                                var bloodGroupListItem = d.createElement('li');
                                bloodGroupListItem.innerText = getBloodTypeWithRhesusText(pie.el.children[0].innerText) + ' ' + currentTargetPercentage + '%';
                                bloodGroupList.appendChild(bloodGroupListItem);
                            });

                            var region = d.querySelector('#blood-group-region');
                            region.innerHTML = bloodGroupList.outerHTML;
                        };

                    [].slice.call(d.querySelectorAll('.js-chart')).forEach(function (chart) {
                        pies.push(new EasyPieChart(chart, {
                            barColor: '#DB3325',
                            scaleColor: false,
                            lineWidth: 24,
                            lineCap: 'circle'
                        }));
                    });
                    [].slice.call(d.querySelectorAll('.js-pie__trigger')).forEach(function (btn) {
                        btn.addEventListener('click', handler), false;
                        btn.addEventListener('touchstart', handler), false;
                    });

                });
            },
            initNearMe = function () {
                if (!(d.querySelector('.sessions-near-me'))) { return; }
                var nearMe = d.querySelectorAll('.sessions-near-me');

                for (var i = 0; i < nearMe.length; i++) {
                    var n = nearMe[i];
                    var form = STORM.UTILS.tools.closest(n, 'form');
                    var myPosition = form.querySelector('.my-position');
                    n.onclick = function (e) {
                        e.preventDefault();
                        if (navigator.geolocation) {
                            navigator.geolocation.getCurrentPosition(function (pos) {
                                var crds = pos.coords;
                                myPosition.value = crds.latitude + "," + crds.longitude;
                                myPosition.parentElement.submit();
                            });
                        }
                    };
                }
            },
            initLocationSearchForm = function () {
                var searchTermOverrides = {
                    'willowbrae': 'willowbrae, edinburgh',
                    'armadale': 'armadale, west lothian',
                    'dalbeattie': 'dalbeattie, dumfries',
                    'blackburn': 'blackburn, west lothian',
                    'blackhall': 'blackhall, edinburgh',
                    'newport': 'newport, fife',
                    'marryat hall': 'marryat hall, dundee',
                    'pennyburn': 'pennyburn, kilwinning',
                    'murray': 'murray, east kilbride',
                    'hillhouse': 'hillhouse, hamilton',
                    'stonehouse': 'stonehouse, ml9',
                    'charleston': 'charleston, iv3',
                    'hilton': 'hilton primary school, inverness',
                    'bowhouse': 'bowhouse, FK3'
                };

                if (d.querySelector('#header-location-search-form')) {
                    var headerForm = d.querySelector('#header-location-search-form');
                    headerForm.onsubmit = function (e) {
                        e.preventDefault();
                        var searchTerm = e.currentTarget[2].value.toLowerCase();
                        if (searchTermOverrides[searchTerm]) {
                            searchTerm = searchTermOverrides[searchTerm];
                        }

                        var myPosition = headerForm.querySelector('.my-position');
                        new google.maps.Geocoder().geocode({ 'address': searchTerm + ", Scotland" }, function (results, status) {
                            if (status === google.maps.GeocoderStatus.OK) {
                                var lat = results[0].geometry.location.lat();
                                var lng = results[0].geometry.location.lng();
                                myPosition.value = lat + "," + lng;
                                myPosition.parentElement.submit();
                            } else {
                                myPosition.value = "not-found";
                                myPosition.parentElement.submit();
                            }
                        });
                    }
                }

                if (d.querySelector('#footer-location-search-form')) {
                    var footerForm = d.querySelector('#footer-location-search-form');
                    footerForm.onsubmit = function (e) {
                        e.preventDefault();

                        var searchTerm = e.currentTarget[2].value.toLowerCase();

                        if (searchTermOverrides[searchTerm]) {
                            searchTerm = searchTermOverrides[searchTerm];
                        }

                        var myPosition = footerForm.querySelector('.my-position');
                        new google.maps.Geocoder().geocode({ 'address': searchTerm + ", Scotland" }, function (results, status) {
                            if (status === google.maps.GeocoderStatus.OK) {
                                var lat = results[0].geometry.location.lat();
                                var lng = results[0].geometry.location.lng();
                                myPosition.value = lat + "," + lng;
                                myPosition.parentElement.submit();
                            } else {
                                myPosition.value = "not-found";
                                myPosition.parentElement.submit();
                            }
                        });
                    }
                }

                if (d.querySelector('#modal-location-search-form')) {
                    var modalForm = d.querySelector('#modal-location-search-form');
                    modalForm.onsubmit = function (e) {
                        e.preventDefault();

                        var searchTerm = e.currentTarget[2].value.toLowerCase();

                        if (searchTermOverrides[searchTerm]) {
                            searchTerm = searchTermOverrides[searchTerm];
                        }

                        var myPosition = modalForm.querySelector('.my-position');
                        new google.maps.Geocoder().geocode({ 'address': searchTerm + ", Scotland" }, function (results, status) {
                            if (status === google.maps.GeocoderStatus.OK) {
                                var lat = results[0].geometry.location.lat();
                                var lng = results[0].geometry.location.lng();
                                myPosition.value = lat + "," + lng;
                                myPosition.parentElement.submit();
                            } else {
                                myPosition.value = "not-found";
                                myPosition.parentElement.submit();
                            }
                        });
                    };
                }
            },
            initSearchUnderline = function () {
                var underlineTemplate = '<span class="search-underline"></span>';

                [].slice.call(d.querySelectorAll('.js-modal-input ')).forEach(function (input) {
                    input.insertAdjacentHTML('beforebegin', underlineTemplate);
                    input.addEventListener('keyup', function (e) {
                        input.previousElementSibling.textContent = input.value;
                    }, false);
                });
            },
            initLocationDropdown = function () {
                if (!!d.querySelector('#locations') && !!d.querySelector('#date-and-time')) {
                    var locations = d.querySelector('#locations');
                    var dateAndTime = d.querySelector('#date-and-time');
                    locations.onchange = function () {
                        var locationId = this.options[this.selectedIndex].value;
                        var http = new XMLHttpRequest();
                        http.open('POST', '/umbraco/surface/OnlineAppointmentCallback/GetLocationSessions', true);
                        http.setRequestHeader('Content-type', 'application/json');
                        http.onreadystatechange = function () {//Call a function when the state changes.
                            if (http.readyState == 4 && http.status == 200) {
                                var items = JSON.parse(http.responseText);
                                console.log(items);
                                dateAndTime.options.length = 0;
                                var opt = d.createElement('option');
                                opt.text = "Select...";
                                opt.value = "";
                                dateAndTime.add(opt);
                                for (var item in items) {
                                    console.log(item);
                                    var date = d.createElement('option');
                                    date.text = items[item].date;
                                    date.value = items[item].date;
                                    dateAndTime.add(date);
                                }
                            }
                        };

                        http.onerror = function () {
                            console.log("Error retrieving sessions");
                        };

                        http.send(JSON.stringify({ locationId: locationId }));
                    };
                }
            },
            initNavPrimary = function () {
                // the storm-toggler library sets all togglers to have an aria-expanded value of false on page load
                // the code below sets this to true if the nav item has a sub-menu and is active
                if (!!d.querySelector('.nav-primary__item--has-subnav.active')) {
                    var toggle = d.querySelector('.nav-primary__item--has-subnav.active .js-toggle__local');
                    toggle.setAttribute('aria-expanded', 'true');
                }
            },
            initCards = function() {
                //detect and return if not needed
                if (!(d.querySelector('.js-card'))) { return; }                

                [].slice.call(d.querySelectorAll('.js-card')).forEach(function (card) {
                    
                    let link = card.querySelector('.js-card__link');
                    card.style.cursor = 'pointer';
                    card.addEventListener('click', e => {  
                        if (link !== e.target) {
                            link.click();
                        }
                    });
                });
            },
            init = function () {
                //initialise everything
                /*
                Modal('.js-modal-trigger-1', '.js-modal-overlay-1');
                Modal('.js-modal-trigger-2', '.js-modal-overlay-2');
                Modal('.js-modal-trigger-3', '.js-modal-overlay-3');
                */
                Modal.init('.js-modal');
                /*
                STORM.UI.modals = Modal.init('.js-modal', {
                    callback: function(){
                        STORM.UI.modals.forEach(function(modal){
                            if(modal !== this && !!modal.isOpen){
                                modal.close();
                            }
                        }.bind(this));
                    }});
                    */
                initCookieBanner();
                initCookieSettings();
                initFonts();
                initErrorSummary();
                initMap();
                initParallax();
                initPies();
                initTabsAccordion();
                initNearMe();
                initQuiz();
                initSmoothScroll();
                initScrollPoints();
                initLocationSearchForm();
                Toggler.init('.js-toggle', { trapTab: true });
                Toggler.init('.js-toggle__local', { local: true, delay: 0 });
                !!d.querySelector('.js-toggle__faq') && Toggler.init('.js-toggle__faq');
                !!d.querySelector('.js-toggle__search-filters') && Toggler.init('.js-toggle__search-filters');
                initNavPrimary();
                initSearchUnderline();
                initCards();
                require('storm-outliner');
                !!d.querySelector('.active .nav-secondary') && (d.documentElement.className += ' on--nav-secondary');
            },
            loaded = function () {
                initWall();
                initEqualizer();
                initLocationDropdown();
                if (!!d.querySelector('.js-jump-to-wall')) {
                    [].slice.call(d.querySelectorAll('.js-jump-to-wall')).forEach(function (el) {
                        el.addEventListener('click', function (e) {
                            e.preventDefault();
                            var elementId = el.getAttribute('href').split('#')[1];
                            d.getElementById(elementId).click();
                            d.getElementById(elementId).focus({ preventScroll: true });
                        });
                    });
                }
            };

        //Interface with/entry point to site JS
        return {
            init: init,
            loaded: loaded
        };

    }(window, document, undefined));

//expose globally
global.STORM = {
    UTILS: UTILS,
    UI: UI
};

//Cut the mustard
//Don't run any JS if the browser can't handle it
if ('addEventListener' in window) {
    window.addEventListener('DOMContentLoaded', STORM.UI.init, false);
    window.addEventListener('load', STORM.UI.loaded, false);
}
